import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserData } from "../../models/user";
import { AngularFirestore } from '@angular/fire/firestore';
import { firestore } from 'firebase/app';

@Injectable({
  providedIn: 'root'
})

export class UserService {

  public URIconnect = environment.URL_API + "/users/"

  constructor(
    private http: HttpClient,
    private afs: AngularFirestore
  ) { }

  async getAllUsers() {
    try {
      var response = await this.http.get<{ code: number, data: UserData[] }>(this.URIconnect).toPromise()
      return response
    } catch (error) {
      throw error
    }
  }

  async getActiveUsers() {
    try {
      var response = await this.http.get<{ code: number, data: UserData[] }>(this.URIconnect + "getActive").toPromise()
      return response.data
    } catch (error) {
      console.log(error);
      throw error
    }
  }

  async getAdmins() {
    try {
      var response = await this.http.get<{ code: number, data: UserData[] }>(this.URIconnect + "admins").toPromise()
      return response.data
    } catch (error) {
      throw error
    }
  }

  async getUserById(uid: string) {
    try {
      var clients = await this.http.get<{ code: number, data: UserData }>(this.URIconnect + uid).toPromise();
      return clients.data
    } catch (error) {
      throw error
    }
  }

  async getUserByEmail(email: string) {
    try {
      var clients = await this.http.get<{ code: number, data: UserData }>(this.URIconnect + email).toPromise();
      return clients.data
    } catch (error) {
      throw error
    }
  }

  async addNewUser(user) {
    try {
      await this.http.post<{ code: number, data: any }>(this.URIconnect, { data: user }).toPromise()
      return
    } catch (error) {
      if (error.status === 409) {
        throw new Error("El correo ya está registrado. Intenta con otro.")
      }
    throw new Error("Error al registrar usuario. Intenta más tarde.")
    }
  }

  async updateUser(_id: string, user: UserData) {
    try {
      await this.http.put<any>(this.URIconnect + _id, { data: user }).toPromise()
      return
    } catch (error) {
      throw error
    }
  }

  async deleteUser(uid: string) {
    try {
      await this.http.delete<any>(this.URIconnect + uid).toPromise()
      return "User delete"
    } catch (error) {
      throw error
    }
  }

  async saveUserToken(uid: string, token: string) {
    const userRef = this.afs.collection('usuarios').doc(uid);
    const userDoc = await userRef.get().toPromise();

    // Obtener tokens existentes (si no existe el doc, se inicializa vacío)
    let tokens: string[] = userDoc.exists ? (userDoc.data()?.token || []) : [];

    // Eliminar duplicados
    tokens = tokens.filter(t => t && t !== token);

    // Agregar el nuevo
    tokens.push(token);

    if (userDoc.exists) {
      await userRef.update({ token: tokens });
    } else {
      // crea el doc si no existe
      await userRef.set(
        {
          uid,
          token: tokens,
          createdAt: new Date(),
        },
        { merge: true }
      );
    }

    //console.log('✅ Tokens actualizados en Firestore:', tokens);
}


}
